import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AggregateContactsService {

  constructor(private http: HttpClient) { }

  backfill30Days(accountId: string): Observable<any> {
    return this.http
    .get(`/api/v1/aggregate/contacts/${accountId}/30`);
  }
}



// WEBPACK FOOTER //
// ./client/app/services/aggregate-contacts.service.ts